
import { OnInit, Directive } from "@angular/core";
import { EvaluationProductFilter } from "@app-model/evaluation";
import { DashboardChartComponent } from "../dashboard-chart/dashboard-chart.component";

@Directive()
export class EvalDashboardChartComponent extends DashboardChartComponent implements OnInit {
  evalGroupingLabels = {
    STATUS: 'Status',
    EVAL_DEALER: 'Unidades',
    SELLER: 'Vendedores',
    EVALUATOR: 'Avaliadores',
    PRICING_USER: 'Precificadores',
    SELLER_MANAGER_PRICE_UPDATE: 'Gerentes com alteração de preço',
    CITY: 'Cidades',
    UF: 'UFs',
    OEM_DEALER: 'Grupos',
    REGIONAL: 'Regionais',
    MAKE: 'Marcas',
    MODEL: 'Modelos',
    YEAR: 'Anos',
    MODEL_YEAR: 'Modelos + ano',
    SCORE: 'Nota',
    SCORE_ABC: 'Nota A/B/C',
    DESTINATION: 'Destino',
    EVAL_REASON: 'Motivo',
    EVAL_TYPE: 'Tipo',
    PRICE: 'Preços',
    DAY: 'Data',
    WEEKDAY: 'Dia da semana',
    OWNER_TYPE: 'Proprietário',
    REASON: "Motivo",
    MONTH: "Visão acumulada"
  };

  evalStatusLabels = {
    'Aguardando RaioX' : 'CREATED',
    'Em precificação' : 'PRICING',
    'Em negociação': 'NEGOTIATION',
    'Captadas': 'BOUGHT',
    'Captada': 'BOUGHT',
    'Vendidas (cotação rápida)': 'SOLD_FAST_QUOTE',
    'Vendas (cotação rápida)': 'SOLD_FAST_QUOTE',
    'Venda (cotação rápida)': 'SOLD_FAST_QUOTE',
    'Canceladas': 'CANCELLED',
    'Arquivadas': 'ARCHIVED',
    'Expiradas': 'EXPIRED',
    'Finalizada' : 'FINISHED',
    'Finalizadas' : 'FINISHED',
    'Enviada para captação' : 'SENT_TO_EVAL',
    'Enviadas para captação' : 'SENT_TO_EVAL',
    'Agendada' : 'SENT_TO_EVAL',
    'Agendadas' : 'SENT_TO_EVAL',
    'Troca por novo' : 'EXCHANGE_NEW',
    'Troca por usado' : 'EXCHANGE_USED',
    'Venda' : 'SELL_ONLY',
    'Consignado' : 'CONSIGNED'

  };

  filter: EvaluationProductFilter;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getEvalGroupingLabel(grouping: string): string {
    return this.evalGroupingLabels[grouping];
  }


}
